import merge from 'lodash-es/merge';
import shoppingTheme from '@/modules/game-shopping/theme';

import bgImage from './views/background.jpg';

export default merge({}, shoppingTheme, {
    windowBackground: `#101553 url(${bgImage}) center/cover`,
    background: 'linear-gradient(#2EA79E, #00000000)',
    shelfBackground: '#2EA79E66'
});
